import {GuidePostSerializer} from "@oldDashboard/legacyModels/serializers/guidePostSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
export class CommandGetTopGuidePosts {
    async run(afiliateSelected: String, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String)  {
        const path = `get-chart-data/client:top-performing-ideas/?affiliate_id=${afiliateSelected}&launch_id=${launchSelected}&time_period=${timePeriodSelected}&start_date=${startDate}&end_date=${endDate}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success) {
                return this.deserialize(response.chart_data.data.ideas);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) {
        const serializer = new GuidePostSerializer();
        return serializer.deserializeList(data);
    }
}

